import React, {Component} from 'react';
import {Button, Modal, Icon} from 'semantic-ui-react';

export default class InstructionModal extends Component {
  render() {
    const {
      isOpen,
      header,
      className,
      content,
      close,
      note,
      buttonText
    } = this.props;
    const modalContent = content && Array.isArray(content) && !!(content.length) ? content.map(name => <p>{name}</p>) : content;

    return (
      <Modal className={className} dimmer="blurring"
             size='tiny' open={isOpen}>
        <Modal.Header>
          <p>{header}</p>
        </Modal.Header>
        <Modal.Content scrolling>
          {modalContent}
          {
            note &&
            <p className="note"><i>{note}</i></p>
          }
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={close} primary>
            <Icon className="m0" center/>{buttonText}</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InstructionModal/InstructionModal.js